import { Layers } from 'lucide-react'
import { useKioskStacks, type KioskStack } from '@/lib/kiosk'
import { Panel } from '@/components/kiosk/kioskUi'
import { C } from '@/components/kiosk/kioskTheme'

function byName(a: KioskStack, b: KioskStack): number {
  return a.name.localeCompare(b.name)
}

function StackChip({ s, big = false }: { s: KioskStack; big?: boolean }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md ${big ? 'px-2.5 py-1.5 text-sm' : 'px-2 py-1 text-[11px]'}`}
      style={{ background: C.panelHi, border: `1px solid ${C.line}` }}
    >
      <span className="truncate font-semibold" style={{ color: C.ink }}>{s.name}</span>
      <span className="kmono shrink-0" style={{ color: C.cyan }}>{s.services_count}</span>
    </span>
  )
}

export function StacksTile({ onTap }: { onTap: () => void }) {
  const { data: stacks } = useKioskStacks()
  const list = [...(stacks ?? [])].sort(byName)
  return (
    <Panel
      title="Stacks"
      icon={<Layers className="h-3.5 w-3.5" />}
      accent={C.cyan}
      onTap={onTap}
      right={<span className="kmono text-sm font-bold" style={{ color: C.ink }}>{list.length}</span>}
    >
      <div className="flex h-full flex-wrap content-start gap-1.5 overflow-hidden">
        {list.map((s) => <StackChip key={s.name} s={s} />)}
        {list.length === 0 && <span className="text-sm" style={{ color: C.faint }}>Aucune stack</span>}
      </div>
    </Panel>
  )
}

export function StacksDetail() {
  const { data: stacks } = useKioskStacks()
  const list = [...(stacks ?? [])].sort(byName)
  const totalServices = list.reduce((n, s) => n + s.services_count, 0)
  return (
    <div className="flex h-full flex-col gap-3">
      <div className="flex gap-2">
        <div className="rounded-lg px-3 py-1.5" style={{ background: C.panelHi }}>
          <span className="kmono text-xl font-bold" style={{ color: C.cyan }}>{list.length}</span>
          <span className="ml-2 text-[11px] uppercase" style={{ color: C.dim }}>stacks</span>
        </div>
        <div className="rounded-lg px-3 py-1.5" style={{ background: C.panelHi }}>
          <span className="kmono text-xl font-bold" style={{ color: C.ink }}>{totalServices}</span>
          <span className="ml-2 text-[11px] uppercase" style={{ color: C.dim }}>services</span>
        </div>
      </div>
      <div className="grid min-h-0 flex-1 grid-cols-4 content-start gap-2.5 overflow-hidden">
        {list.map((s) => (
          <div key={s.name} className="kcard flex items-center justify-between rounded-lg border px-3 py-2"
            style={{ background: C.panel, borderColor: C.line }}>
            <span className="truncate text-sm font-semibold" style={{ color: C.ink }}>{s.name}</span>
            <span className="kmono ml-2 shrink-0 text-sm" style={{ color: C.cyan }}>{s.services_count}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
